import { createFileRoute, Link, Outlet, redirect, useMatchRoute } from '@tanstack/react-router';
import { env } from '../../config/env';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async ({ location }) => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: DashboardLayout,
});

function DashboardLayout() {
  const matchRoute = useMatchRoute();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    window.location.href = '/login';
  };

  const isDev = env.ENABLE_DEV_TOOLS;

  const navLinks = [
    { to: '/dashboard', label: 'Dashboard' },
    // { to: '/dashboard/leagues', label: 'Leagues' },
    { to: '/dashboard/pickems', label: 'Pickems' },
    { to: '/dashboard/feeds', label: 'Feeds' },
    { to: '/dashboard/pages', label: 'Pages' },
  ];

  return (
    <div className="flex h-screen">
      <aside className="w-64 border-r bg-card flex flex-col">
        <div className="p-4">
          <h1 className="text-2xl font-bold">Saracen Pickem Admin</h1>
        </div>
        <nav className="flex-1 p-4 space-y-2">
          {navLinks.map(link => {
            // Use exact matching for Dashboard, fuzzy for others
            const isActive =
              link.to === '/dashboard'
                ? matchRoute({ to: link.to, fuzzy: false })
                : matchRoute({ to: link.to, fuzzy: true });
            return (
              <Link
                key={link.to}
                to={link.to}
                className={cn(
                  'block px-4 py-2 rounded transition-colors',
                  isActive ? 'bg-primary text-primary-foreground' : 'bg-white/10 hover:bg-accent'
                )}
              >
                {link.label}
              </Link>
            );
          })}
          {isDev && (
            <>
              <div className="my-2 border-t border-yellow-500/50" />
              <Link
                to="/dashboard/dev-tools"
                className={cn(
                  'block px-4 py-2 rounded transition-colors border border-yellow-500/50',
                  matchRoute({ to: '/dashboard/dev-tools', fuzzy: true })
                    ? 'bg-yellow-100 dark:bg-yellow-950/50 text-yellow-900 dark:text-yellow-100'
                    : 'bg-yellow-50/50 dark:bg-yellow-950/30 text-yellow-800 dark:text-yellow-200 hover:bg-yellow-100 dark:hover:bg-yellow-950/50'
                )}
              >
                ⚙️ Dev Tools
              </Link>
            </>
          )}
        </nav>
        <div className="p-4 border-t">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 text-left rounded hover:bg-accent transition-colors"
          >
            Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
